/**
 * @googlePixel 配置中心参数 google_pixel_code
 *
 * 强化转化：
 * https://support.google.com/google-ads/answer/13258081?visit_id=638757041837406787-3105209161&rd=2
 *
 */

// sdk 引入一次即可
export function googlePixelSdk(pixel_id) {
	if (!import.meta.client) return;

	try {
		var gb = document.createElement("script");
		gb.src = `https://www.googletagmanager.com/gtag/js?id=${pixel_id}`;
		gb.async = true;

		// 添加加载错误处理
		gb.onerror = function () {
			console.warn("Google Analytics脚本加载失败，可能是网络问题或被广告拦截器阻止");
		};

		var s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(gb, s);

		window.dataLayer = window.dataLayer || [];
		window.gtag = function () {
			try {
				window.dataLayer.push(arguments);
			} catch (error) {
				console.warn("Google Analytics数据推送失败:", error);
			}
		};

		const email = localStorage.getItem("gw_token_email"),
			phone = localStorage.getItem("gw_token_phone");

		if (email || phone) {
			// 转化页添加：强化转化参数
			window.enhanced_conversion_data = {
				email,
			};
			// 事件代码上报
			gtag("set", "user_data", {
				email,
				phone_number: phone,
			});
		}
	} catch (error) {
		console.error("Google Pixel SDK初始化失败:", error);
	}
}

// 初始化
export function initGooglePixel(googlePixel) {
	if (!import.meta.client) return;
	if (window.googlePixelSdkLoaded) return;
	try {
		if (googlePixel && googlePixel.length > 0) {
			googlePixelSdk(googlePixel[0].id); //初始化一个即可

			setTimeout(() => {
				try {
					gtag("js", new Date());

					// config重复执行即可
					googlePixel.forEach(v => {
						try {
							if (v.allow_enhanced_conversions) {
								// 强化转化
								gtag("config", v.id, { allow_enhanced_conversions: true });
								console.log("初始化", v.id, "allow_enhanced_conversions");
							} else {
								gtag("config", v.id);
								console.log("初始化", v.id);
							}
						} catch (pixelError) {
							console.warn(`Google Pixel配置失败 (ID: ${v.id}):`, pixelError);
						}
					});

					window.googlePixelSdkLoaded = true;
				} catch (initError) {
					console.error("Google Pixel初始化失败:", initError);
				}
			}, 500);
		}
	} catch (error) {
		console.error("Google Pixel初始化过程中发生错误:", error);
	}
}

// 完成购买事件
export function resultGooglePixelCode(googlePixel, orderId, amount, prop_currency) {
	if (!import.meta.client) return;

	if (googlePixel && typeof googlePixel === "string") {
		googlePixel = JSON.parse(googlePixel);
	}
	if (window.gtag && googlePixel && googlePixel.length > 0) {
		setTimeout(() => {
			googlePixel.map(v => {
				let huobi = prop_currency || v.currency || "USD"; // 默认为USD

				// ga标准事件
				if (!!v.id.match(/(UA|G)/i)) {
					gtag("event", "purchase", {
						currency: huobi,
						value: Number(v.price) || amount,
						transaction_id: orderId,
					});

					console.log(`google ga event 购买 : ${v.id}`);
				}

				// aw事件
				if (v.purchase) {
					gtag("event", "conversion", {
						send_to: v.purchase, //示例：'AW-578483137/FbnoCPjAt-oCEMHn65MC',
						value: Number(v.price) || amount,
						currency: huobi,
						transaction_id: orderId,
					});

					console.log(`google aw event 购买: ${v.purchase}`);
				}
			});
		}, 500);
	}
}

/**
 * 其他自定义事件封装
 * @param {Array} googlePixel
 * @param {string} evenName
 * @param {Object} options 可选参数，支持 value 和 currency
 */
export function googleOtherEvent(googlePixel, evenName, options = {}) {
	if (!import.meta.client) return;

	if (googlePixel && typeof googlePixel === "string") {
		googlePixel = JSON.parse(googlePixel);
	}
	if (window.gtag && googlePixel && googlePixel.length > 0) {
		setTimeout(() => {
			googlePixel.map(v => {
				// aw事件
				if (v.hasOwnProperty(evenName)) {
					console.log(`google aw event: ${evenName}`, v[evenName]);
					const eventParams = { send_to: v[evenName] };
					// 如果提供了value和currency，则添加到事件参数中
					if (options.value !== undefined) {
						eventParams.value = options.value;
					}
					if (options.currency) {
						eventParams.currency = options.currency;
					}
					gtag("event", "conversion", eventParams);
					console.log(`google aw event: ${evenName} 上报成功`);
				}
			});
		}, 500);
	}
}
